import React, { Suspense } from "react";
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import "./i18n.js";
import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
//WW-456[12/15/2022]Importing auth0 - provider -with-history to access the Auth0 react SDK to do SSO - Poornima S
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";

require('bootstrap/dist/js/bootstrap.min.js');
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
console.log = () => { };//Add these two line in Deployment machines only - Divis.
console.error = () => { };// This change is added by Divis, but don't check in this, if you do so you will not be able to write console log and console error in any other machines.

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Suspense fallback="loading">
            <Auth0ProviderWithHistory>
                <App />
            </Auth0ProviderWithHistory>
        </Suspense>
    </BrowserRouter>,
    rootElement);

//registerServiceWorker();
//Removal of service Workers - Deepthi N H
unregister();
